<template>
<loader v-bind="{ loading }">
  <div>
    <columns>
      <column>
        <text-input 
          :error="$root.errorBag.cvid" 
          :value="vulnerability.cvid" 
          @input="updateCvid"
          placeholder="Database User">
          CVID
        </text-input>
      </column>
      <column class="is-narrow">
        <number-input 
          :error="$root.errorBag.cvss" 
          :value="vulnerability.cvss" 
          @input="updateCvss"
          :precision="2"
          :max="10"
          :min="0">
          CVSS Score
        </number-input>
      </column>
    </columns>

    <columns>
      <column class="is-narrow">
        <switch-input
          classes="is-rounded"
          :value="vulnerability.default_exposure"
          @input="toggleDefaultExposure"
          description="Are customer attributes vulnerable by default?">
          Default Exposure
        </switch-input>
      </column>
      <column class="is-narrow">
        <switch-input
          classes="is-rounded"
          :value="vulnerability.requires_poc"
          @input="toggleRequiredPoc"
          description="If this vulnerability does not require a POC, it simply requires a software update">
          POC Required
        </switch-input>
      </column>
    </columns>
    <columns>
      <column>
        <text-area 
          :error="$root.errorBag.description" 
          :value="vulnerability.description"
          @input="updateSummary">
          Summary of Vulnerability
        </text-area>
        <text-area 
          :error="$root.errorBag.recommendation" 
          :value="vulnerability.recommendation"
          @input="updateRecommendation">
          Recommendation
        </text-area>
      </column>
    </columns>
  </div>

  <columns class="mt-2">
    <column>
      <submit-button 
        :working="working" 
        @submit="save" 
        left-icon="save">
        Save
      </submit-button>
    </column>
  </columns>

</loader>
</template>
<script>
import { updateVulnerability, addCheckpointToVulnerability, removeCheckpointToVulnerability } from '@/api/super'
import { getPath } from '@/api/common'
import { findIndex } from 'lodash'
import { mapGetters, mapMutations } from 'vuex'

export default {
  
  data: () => ({
    loading: true,
    working: false,
    addingPoc: false,
  }),

  beforeCreate() {
    this.$store.dispatch('vulnerability/loadVulnerability', this.$route.params.vulnerability).then(() => {
      this.loading = false
    })
  },

  methods: {
    ...mapMutations('vulnerability', [
      'updateCvid',
      'updateSummary',
      'updateRecommendation',
      'toggleRequiredPoc',
      'toggleDefaultExposure',
      'updateCvss'
    ]),
    save() {
      this.working = true
      updateVulnerability(this.vulnerability, response => {
        this.working = false
        this.$toast.success('saved')
      }, error => {
        this.working = false
      })
    },
  },

  computed: {
    ...mapGetters('vulnerability', [
      'vulnerability'
    ])
  }

}
</script>